module.exports = __webpack_public_path__ + "static/assets/ae1b9be9ac5a0793b990a0ba5231c662.png";